import { Option } from '../types';

export enum PurchasedFrom {
  Dealer = 'Dealer',
  PrivateSeller = 'Private seller',
  Refinance = 'Refinance',
}

export const PURCHASED_FROM_OPTIONS: Option<string>[] = [
  {
    label: 'Dealer',
    value: PurchasedFrom.Dealer,
  },
  {
    label: 'Private seller',
    value: PurchasedFrom.PrivateSeller,
  },
  {
    label: 'Refinance',
    value: PurchasedFrom.Refinance,
  },
];
